import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import './utils/fontOptimizer';
import { AudioProvider } from './contexts/AudioContext';
import { migrateQuranCacheOnVersionChange } from './utils/quranCacheMigration';
import ErrorBoundary from './components/ErrorBoundary';

// Before any component reads localStorage mirrors of static JSON
migrateQuranCacheOnVersionChange();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AudioProvider>
        <App />
      </AudioProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();

registerServiceWorker({
  onUpdate: () => {
    try {
      window.dispatchEvent(new CustomEvent('quran-sw-update'));
    } catch {
      /* ignore */
    }
  },
});
